export const environment = {
  production: true,
  mixpanelToken: 'fd6ffbb72d0d7bfdee7cf332bf239841',
};
